import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { getFont } from '@finect/tabular-utils/getFont';
import { fontSmoothing } from '@finect/tabular-utils/fontSmoothing';
var SIZES = {
  small: -2,
  medium: -1
};
export var Tip = styled.div.withConfig({
  displayName: "Tooltip__Tip",
  componentId: "sc-1fr0ei1-0"
})(["", ";display:inline-block;position:absolute;z-index:2;", " ", " ", " visibility:hidden;transform:", ";"], function (_ref) {
  var width = _ref.width;
  return width ? "width: ".concat(width, ";") : null;
}, function (_ref2) {
  var position = _ref2.position;
  return position === 'top' ? 'bottom: 100%; margin-bottom: 9px;' : 'top: 100%;';
}, function (_ref3) {
  var parentAbsolute = _ref3.parentAbsolute;
  return parentAbsolute ? 'top: 25px;' : '';
}, function (_ref4) {
  var from = _ref4.from;
  return from === 'left' ? 'left: 0;' : from === 'right' ? 'right: 0;' : 'left: 50%;';
}, function (_ref5) {
  var from = _ref5.from;
  return from === 'left' || from === 'right' ? 'none' : 'translateX(-50%)';
});
export var InnerTip = styled.div.withConfig({
  displayName: "Tooltip__InnerTip",
  componentId: "sc-1fr0ei1-1"
})(["", ";opacity:0;padding:4px 9px;border-radius:3px;background-color:", ";", " font-weight:400;", ";color:#fff;text-align:", ";transform:translateY(-1px);user-select:none;", ";&:before{position:absolute;", ";", ";width:0;height:0;border-width:0 4px 4px;border-style:solid;border-color:", ";margin-left:", ";content:'';", ";}", ";"], function (_ref6) {
  var width = _ref6.width;
  return width ? "width: ".concat(width, ";") : null;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.uiDD;
}, function (_ref8) {
  var _ref8$size = _ref8.size,
    size = _ref8$size === void 0 ? 'medium' : _ref8$size;
  return getFont(SIZES[size], 'compact');
}, fontSmoothing, function (_ref9) {
  var textAlign = _ref9.textAlign;
  return textAlign ? textAlign : 'left';
}, function (_ref10) {
  var breakWord = _ref10.breakWord,
    width = _ref10.width;
  return breakWord ? "\n    overflow-wrap: break-word;\n    word-wrap: break-word;\n    hyphens: auto;\n  " : !width ? 'white-space: nowrap;' : null;
}, function (_ref11) {
  var position = _ref11.position;
  return position === 'top' ? 'bottom: -4px;' : 'top: -4px;';
}, function (_ref12) {
  var from = _ref12.from;
  return from === 'left' ? 'left: 4px;' : from === 'right' ? 'right: 4px;' : 'left: 50%';
}, function (_ref13) {
  var theme = _ref13.theme;
  return "transparent transparent ".concat(theme.colors.uiDD, " transparent");
}, function (_ref14) {
  var from = _ref14.from;
  return from === 'left' || from === 'right' ? 0 : '-6px';
}, function (_ref15) {
  var position = _ref15.position;
  return position === 'top' ? 'transform: rotate(180deg);' : '';
}, maxMediaQueries.phone(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    width: 100%;\n  "]))));
export var TooltipText = styled.div.withConfig({
  displayName: "Tooltip__TooltipText",
  componentId: "sc-1fr0ei1-2"
})(["display:", ";position:relative;", "{", ";}", "{", ";}&:hover{", "{", ";}", "{opacity:1;transform:translateY(4px);transition:opacity 0.15s cubic-bezier(0,1,1,1),transform 0.15s cubic-bezier(0,1,1,1);}}"], function (_ref16) {
  var display = _ref16.display;
  return display ? display : 'inline';
}, InnerTip, function (_ref17) {
  var show = _ref17.show;
  return show ? 'opacity: 1;transform: translateY(4px));' : null;
}, Tip, function (_ref18) {
  var show = _ref18.show;
  return show ? 'visibility: visible' : null;
}, Tip, function (_ref19) {
  var disabled = _ref19.disabled;
  return !disabled ? 'visibility: visible' : null;
}, InnerTip);
export var Tooltip = function Tooltip(_ref20) {
  var _ref20$size = _ref20.size,
    size = _ref20$size === void 0 ? 'medium' : _ref20$size,
    tip = _ref20.tip,
    disabled = _ref20.disabled,
    display = _ref20.display,
    from = _ref20.from,
    textAlign = _ref20.textAlign,
    breakWord = _ref20.breakWord,
    width = _ref20.width,
    children = _ref20.children,
    _ref20$position = _ref20.position,
    position = _ref20$position === void 0 ? 'bottom' : _ref20$position,
    parentAbsolute = _ref20.parentAbsolute,
    show = _ref20.show;
  if (position === 'top') {
    return React.createElement(TooltipText, {
      disabled: disabled,
      display: display,
      show: show,
      position: position
    }, React.createElement(Tip, {
      from: from,
      width: width,
      position: position,
      parentAbsolute: parentAbsolute
    }, React.createElement(InnerTip, {
      size: size,
      textAlign: textAlign,
      width: width,
      breakWord: breakWord,
      from: from,
      position: position
    }, tip)), children);
  }
  return React.createElement(TooltipText, {
    disabled: disabled,
    display: display,
    show: show
  }, children, React.createElement(Tip, {
    from: from,
    parentAbsolute: parentAbsolute
  }, React.createElement(InnerTip, {
    size: size,
    textAlign: textAlign,
    width: width,
    breakWord: breakWord,
    from: from
  }, tip)));
};